"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _vueFroala = require("./vue-froala");
var _default = {
  install: function install(app, options) {
    app.component('Froala', _vueFroala.Froala);
    app.component('FroalaView', _vueFroala.FroalaView);
  }
};
exports["default"] = _default;